export default __webpack_public_path__ + "static/media/Tree5.6701f3fd.png";